import type { CameraApiResponse } from "@src/services/api/cameras-api";
import { getCameraDisplayName, getCameraKeyString, getSiteString } from "@src/utils/key-parser";

export type CameraFilterField = "All" | "Camera ID" | "Name" | "Site";

export function filterCamerasByQuery(
  cameras: CameraApiResponse[],
  query: string,
  field?: CameraFilterField,
): CameraApiResponse[] {
  const normalized = query.toLowerCase().trim();
  if (!normalized) return cameras;

  return cameras.filter((camera) => {
    const cameraKey = getCameraKeyString(camera).toLowerCase();
    const site = getSiteString(camera).toLowerCase();
    const displayName = (camera.name || getCameraDisplayName(cameraKey))?.toLowerCase() ?? "";
    const nickname = camera.nickname?.toLowerCase() ?? "";
    const name = camera.name?.toLowerCase() ?? "";

    switch (field) {
      case "Camera ID":
        return cameraKey.includes(normalized);
      case "Name":
        return displayName.includes(normalized) || nickname.includes(normalized) || name.includes(normalized);
      case "Site":
        return site.includes(normalized);
      default:
        return (
          cameraKey.includes(normalized) ||
          site.includes(normalized) ||
          displayName.includes(normalized) ||
          nickname.includes(normalized) ||
          name.includes(normalized)
        );
    }
  });
}
